<template>
  <div class='table-header'>
    <div :style='cssVars' class='table-header__title' v-for='(title, index) in columnTitlesWithFirstEmptyColumn' :key='index'>
      {{ title }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'TableHeader',
  props: {
    columnTitles: {
      required: true,
      type: Array,
    },
  },
  computed: {
    columnTitlesWithFirstEmptyColumn() {
      const updatedColumnTitleList = [''];
      return updatedColumnTitleList.concat(this.columnTitles);
    },
    cssVars() {
      return {
        '--width': `calc(100% / ${this.columnTitlesWithFirstEmptyColumn.length})`,
      };
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.table-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: rem(20);
  margin-bottom: rem(-12);
  &__title {
    text-transform: uppercase;
    color: var(--text-tertiary);
    font-family: $font-family-regular;
    font-size: rem(12);
    letter-spacing: rem(1.1);
    width: var(--width);
    margin-left: rem(19);
  }
}
</style>
